import * as React from "react"
import { ModalSeeker, ButtonSeeker } from "ui-seeker/core"
import { useTranslation } from "react-i18next"

export default function ConfirmModal({ isOpen, onClose, onConfirm, hotelName }) {
    const { t } = useTranslation('common')
    return <ModalSeeker
        isOpen={isOpen}
        controller={onClose}
        title={t('hotels.changeMain')}
        okBtn={false}
        cancelBtn={false}
    >
        <div style={{ padding: '16px 0' }}>
            <p style={{ marginBottom: '16px' }}>
                {t('hotels.setMainConfirmBefore')} <strong>{hotelName}</strong> {t('hotels.setMainConfirmAfter')}
            </p>
            <p style={{ marginBottom: '24px', color: '#666', fontSize: '13px' }}>
                {t('hotels.setMainNote')}
            </p>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                <ButtonSeeker variant="outlined" onClick={onClose}>
                    {t('actions.cancel')}
                </ButtonSeeker>
                <ButtonSeeker variant="contained" color="primary" onClick={onConfirm}>
                    {t('actions.confirm')}
                </ButtonSeeker>
            </div>
        </div>
    </ModalSeeker>
}
